<div class="container" [ngClass]="type">
    <div class="icon" *ngIf="showIcon">
        <fa-icon [icon]="icon"></fa-icon>
    </div>
    <div class="message">
        <ng-content></ng-content>
    </div>
</div>